import { Component, Input, Output, EventEmitter, ContentChild, ElementRef, AfterContentInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICONS } from '../../../_helpers/icons.constants';
import { DEFAULT_MODAL_CONFIG, ModalConfig } from './modal.modal';

@Component({
  selector: 'ds-modal',
  templateUrl: './modal.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ModalComponent implements AfterContentInit {
  public ICONS = ICONS;
  @Output() visibleChange = new EventEmitter<boolean>();


  // Emit when the modal is confirmed (e.g. Save/OK)
  @Output() confirmed = new EventEmitter<any>();

  // Content projection detection
  @ContentChild('[modal-header]', { read: ElementRef }) projectedHeader?: ElementRef;
  @ContentChild('[modal-footer]', { read: ElementRef }) projectedFooter?: ElementRef;

  public _modalInput: ModalConfig = { ...DEFAULT_MODAL_CONFIG };
  @Input() modalInput!: ModalConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.modalInput) {
      const val: ModalConfig = changes.modalInput.currentValue || {};
      this.modalInput = { ...DEFAULT_MODAL_CONFIG, ...val };
    }
  }

  hasProjectedHeader = false;
  hasProjectedFooter = false;

  ngAfterContentInit(): void {
    this.hasProjectedHeader = !!this.projectedHeader;
    this.hasProjectedFooter = !!this.projectedFooter;
  }

  // Returns the header icon path (if any) depending on the variant
  get headerIcon(): string | null {
    switch (this.modalInput?.variant) {
      case 'error':
        return this.ICONS.ALERT_CIRCLE;
      case 'success':
        return this.ICONS.CHECK_CIRCLE;
      case 'warning':
        return this.ICONS.WARNING;
      default:
        return null;
    }
  }

  get headerIconAlt(): string {
    switch (this.modalInput?.variant) {
      case 'error':
        return 'Error';
      case 'success':
        return 'Success';
      case 'warning':
        return 'Warning';
      default:
        return '';
    }
  }

  open(data?: any) {
    if (data !== undefined) this.modalInput.data = data;
    this.modalInput.visible = true;
    this.visibleChange.emit(true);
  }

  close() {
    this.modalInput.visible = false;
    this.visibleChange.emit(false);
  }

  confirm(payload?: any) {
    this.confirmed.emit(payload !== undefined ? payload : this.modalInput.data);
    this.close();
  }
}
